import {
  getArticleList
} from '@/api'
import share from '@/mixins/share-finder.js'
import dateFormat from '@/utils/dateformat.js'
import { mapState } from 'vuex'
import { querySubscribeApi } from '../../api/services/launcher-user'
import url from "url";

export default {
  name: 'article-list',
  mixins: [share],
  data() {
    return {
      list: [],
      banner: null,
      columnInfo: null,
      noMore: false,
      isLoading: false,
      msg: '正在加载',
      inited: false,
      subscribed: false,
      subscribeTempleteList: [],
      channel_id:'',
      hasLeaveTracked: false,
      enterTime: 0, //进入时间
    }
  },
  filters: {
    handleTitle(item) {
      if (!item.title) return ''
      if (item.imageUrl) {
        if (item.title.length > 25) {
          return item.title.slice(0, 25) + '...'
        }
      }
      if (!item.imageUrl) {
        if (item.title.length > 37) {
          return item.title.slice(0, 37) + '...'
        }
      }
      return item.title
    },
    dateFormat(date) {
      return dateFormat(date, 'yyyy-mm-dd')
    }
  },
  computed: {
    ...mapState(['wechatUser', 'serviceConfig', 'wxConfigSuccess']),
    type() {
      return this.$route.params.type
    },
    title() {
      let urlTitle = this.serviceConfig.projectName
      if (urlTitle) {
        return urlTitle
      }
      return ''
    },
    subscribeTempleteHtml() {
      return this.subscribeTempleteList.length ? this.subscribeTempleteList.join(',') : ''
    }
  },
  async created() {
    this.enterTime = Date.now()
    let query = url.parse(window.location.toString(), true).query
    if(query.channel_id) {
      this.channel_id = query.channel_id
    }
    if (query.token) {
      this.$store.commit('SET_WX_CONFIG_SUCCESS', true)
    }
    this.setDocumentTitle(this.title)
    this.initSubscribeElement()
    await this.getArticleList()
    this.inited = true
  },
  mounted () {
    this.initLoadMore()
    window.addEventListener('pagehide', this.handlePageLeave, { capture: true });
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    window.removeEventListener('pagehide', this.handlePageLeave, { capture: true });
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.handlePageLeave(); // 路由切换时兜底
  },
  methods: {
    handlePageLeave() {
      if (this.hasLeaveTracked) return;
      this.hasLeaveTracked = true;
      const { page_source = '', channel_id = '' } = url.parse(window.location.toString(), true).query
      this.$sa.track('$WebPageLeave', {
        page_title: "article_column_page",
        column_id: this.$route.params.type,
        column_name:this.columnInfo.name,
        page_source,
        channel_id,
        '$event_duration':(Date.now() - this.enterTime)/1000,
      })
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this.handlePageLeave()
      }
    },
    searchDetail(item) {
      this.$router.push({
        path: `/launcher-article/${item.newsId}`,
        query: {
          columnName: item.columnCode,
          source: 'column',
          channel_id: this.channel_id,
          page_source: 'article_column_page'
        }
      })
    },
    async getArticleList() {
      if (this.isLoading) return
      this.isLoading = true
      let {token} = this.wechatUser
      let params = {
        columnCodes: this.type,
        appCode: this.serviceConfig.appCode,
        showPermission: 1,
        direction: 'DOWN',
        end: new Date().getTime(),
        limit: '20',
        hasTop: 1,
        token
      }
      if (this.list.length > 0) {
        params.sortTimestamp = this.list[this.list.length-1].sortTimestamp
      }
      const res = await getArticleList(params)
      let result = res && res.data || {}
      if (result.data && result.data.length === 0) {
        this.noMore = true
        this.msg = '没有更多了'
      }
      if (result.code !== 1 || (result.data && result.data.length === 0)) return
      this.columnInfo = result.data[0].columnBeans.find(item => item.code === this.type)
      this.banner = this.columnInfo.coverImage
      let tmpList = result.data.map((item) => {
        return {
          id: item.id,
          title: item.title,
          imageUrl: item.attribute.listImageUrl,
          publishTime: item.publishTime,
          newsId: item.newsId,
          columnCode: this.type,
          sortTimestamp: item.sortTimestamp
        }
      }).slice(0, 20)
      if (this.list.length === 0) {
        this.list = tmpList
      } else {
        this.list = this.list.concat(tmpList)
      }
      this.isLoading = false
      this.configShareOptions()
      this.$sa.track('enter_column_page', {
        column_id: this.$route.params.type,
        column_name: this.columnInfo.name,
        is_not_free: false,
        channel_id: this.channel_id,
      })
    },
    setDocumentTitle(title) {
      document.title = title
      let i = document.createElement('iframe')
      i.style.display = 'none'
      i.onload = function () {
        setTimeout(() => {
          i.remove()
        }, 0)
      }
      document.body.appendChild(i)
    },
    configShareOptions() {
      this.$store.dispatch('set_share_info', {
        name: this.columnInfo.name || this.serviceConfig.projectName,
        title: this.columnInfo.name || this.serviceConfig.title,
        desc: this.columnInfo.introduction || this.serviceConfig.desc,
        imgUrl: this.columnInfo.coverImage || this.serviceConfig.image,
        columnName: this.columnInfo.name,
        cb: this.onMenuShare
      })
    },
    initLoadMore () {
      document.getElementById('article-list').addEventListener('scroll', () => {
        let dom = document.querySelector('.list-wrapper')
        if (this.noMore || this.isLoading) return
        const {clientHeight, scrollHeight, scrollTop} = dom
        if (Math.ceil(scrollTop) + 5 >= Math.floor(scrollHeight - clientHeight)) {
          this.getArticleList()
        }
      }, true)
    },
    async registerSubscribeElement() {
      await this.querySubscribe()
      var btns = document.getElementsByClassName('subscribe-btn');
      const that = this
      if (!btns) return
      for (let i = 0; i < btns.length; i++) {
        let btn = btns[i]
        const item = that.list[btns[i].getAttribute('data-index')]
        btn.addEventListener('success', function () {     
          // 成功失败都跳详情
          that.searchDetail(item)
        });   
        btn.addEventListener('error',function (e) {
          // 成功失败都跳详情
          if (e.detail === 20006) that.searchDetail(item)
        });
      }
    },
    async querySubscribe() {
      let triedTime = 0
      const sleep = () => new Promise(resolve => setTimeout(() => resolve(), 300))
      while (!this.wechatUser || !this.wechatUser.openid) {
        if (triedTime >= 500) break;
        await sleep()
        triedTime++
      }
      const params = {
        openId: this.wechatUser.openid,
        originId: this.serviceConfig.originId,
        templateIds: this.serviceConfig.subscribeTemplate.split(',')
      }
      const res = await querySubscribeApi(params)
      if (res && res.code === 1 && res.data && res.data.templatePopUp) {
        for (const [key, value] of Object.entries(res.data.templatePopUp)) {
          if (value) this.subscribeTempleteList.push(key)
        }
      }
      if (this.subscribeTempleteList && this.subscribeTempleteList.length) this.subscribed = false
      else this.subscribed = true
    },
    formatSubscribeHtml(item) {
      return `
        <div class="subscribe-container">
          ${item.imageUrl ? `<img src="${item.imageUrl}" class="list-img"/>` : ''}
          <div class="list-des ${item.imageUrl ? 'hasImg' : 'withoutImg'}">
            <p class="article-title">${this.$options.filters.handleTitle(item)}</p>
            <p class="article-time">${this.$options.filters.dateFormat(item.publishTime)}</p>
          </div>
        </div>
      `
    },
    async initSubscribeElement() {
      const sleep = () => new Promise(resolve => setTimeout(() => resolve(), 300))
      while (!this.wxConfigSuccess || (!this.list || !this.list.length)) {
        await sleep()
      }
      console.log(this.serviceConfig, '!!!')
      // 不配置模板则不初始化
      if (this.wxConfigSuccess && !this.serviceConfig.subscribeTemplate) return
      this.registerSubscribeElement()
    }
  },
}
